import { useState, useEffect } from "react";

export const useGetIsSideRailShown = (showSideRail: boolean | undefined) => {
  // Track if side rail is actually visible based on screen size and showSideRail config
  // Side rail is visible when: showSideRail is true AND screen width >= 1280px (xl breakpoint)
  const [isSideRailVisible, setIsSideRailVisible] = useState(false);

  useEffect(() => {
    const updateSideRailVisibility = () => {
      const isXlScreen = window.innerWidth >= 1280;
      setIsSideRailVisible(Boolean(showSideRail) && isXlScreen);
    };

    // Set initial state
    updateSideRailVisibility();

    // Listen for window resize
    window.addEventListener("resize", updateSideRailVisibility);
    return () => window.removeEventListener("resize", updateSideRailVisibility);
  }, [showSideRail]);

  return { isSideRailVisible };
};
